// extracted by mini-css-extract-plugin
export default {"wrapper":"type-box_wrapper__5ObZD"};